import React from "react";
import searchIcon from "../../assets/searchIcon.svg";
import styles from "./Search.module.scss";

const Search = () => {
  return (
    <div className={styles.container}>
      <img src={searchIcon} alt="search-icon" />
      <input type="text" placeholder="Search Nfts, Collections & Accounts" />
    </div>
  );
};

export default Search;
